module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164457_HDR-removebg-preview-8087884a77c59c95bf8f1456d39bfafe.png";